import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from './confirm-enable-screen-negative-payment.component';

export interface LocalDialogData {
  amount: string;
  name: string;
}

@Component({
  selector: 'app-confirm-refund',
  templateUrl: './confirm-refund.component.html',
  styleUrls: ['./confirm-refund.component.scss']
})


export class ConfirmRefundComponent implements OnInit {

  refundAmount: string = '';
  refundName: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmRefundComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocalDialogData,
  ) {
    this.refundAmount = data.amount;
    this.refundName = data.name;
  }
  ngOnInit(): void {
      
  }
}
